

























import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({ components: { CustomButton } })
export default class CBreadCrumbs extends Vue {
  @Prop() items!: Array<any>;
  @Prop() fileManager!: boolean;
  @Prop() id!: string;

  action(index: number) {
    let foo = this.items.slice(1, index + 1);
    let res = "/";
    foo.forEach(el => {
      res += el.label + "/";
    });
    this.$emit("changePath", res);
  }
}
